import { render, staticRenderFns } from "./zyjzg.vue?vue&type=template&id=4186bcdc&scoped=true"
import script from "./zyjzg.vue?vue&type=script&lang=js"
export * from "./zyjzg.vue?vue&type=script&lang=js"
import style0 from "./zyjzg.vue?vue&type=style&index=0&id=4186bcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186bcdc",
  null
  
)

export default component.exports